import axios from './base'
const url = `/dashboard`
// ========== Dashboard 访问趋势 (新) ==========

// 获取访问趋势（支持筛选）
export function getVisitTrend(params = {}){
  return axios.request({
    url: `${url}/visit-trend`,
    method: "get",
    params,
  })
}

// 获取筛选选项数据
export function getDashboardFilterOptions(){
  return axios.request({
    url: `${url}/filter-options`,
    method: "get",
  })
}

// 获取访问来源统计
export function getVisitSources(params = {}){
  return axios.request({
    url: `${url}/visit-sources`,
    method: "get",
    params,
  })
}

// 获取省市访问量统计
export function getProvinceStats(params = {}){
  return axios.request({
    url: `${url}/province-stats`,
    method: "get",
    params,
  })
}

// 获取渠道访问量统计
export function getChannelStats(params = {}){
  return axios.request({
    url: `${url}/channel-stats`,
    method: "get",
    params,
  })
}
